import { PersonField } from '@shared/data/entity/fields/PersonField';

/** A person field as one line of text: the first person's full name, and a "+N" for any more. */
export function getPersonText(field: PersonField): string {
  const [first, ...more] = field.users;
  const name = first?.fullName ?? '';
  return more.length > 0 ? `${name} +${more.length}` : name;
}
